import {createContext} from "react";

type SourceData = {
    label: string,
    value: string
}

export type SourceBindContextValue = {
    datas: SourceData[]
}

export const SourceBindContext = createContext<SourceBindContextValue>({
    datas: []
});
